import { useMemo } from "react";

import countBy from "lodash/countBy";
import flatMap from "lodash/flatMap";
import orderBy from "lodash/orderBy";
import uniq from "lodash/uniq";

import type { IRTCurrentCampaignData } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";

/**
 * Returns tags from the current campaign configuration sorted by most used tags first.
 * @param currentCampaignConfiguration
 */
export const useCurrentCampaignTags = (currentCampaignConfiguration: IRTCurrentCampaignData | null): string[] => {
    return useMemo(() => {
        if (!currentCampaignConfiguration?.tags) {
            return [];
        }
        const allTags = flatMap(Object.values(currentCampaignConfiguration.tags));
        const tagCounts = countBy(allTags);
        const uniqueTags = uniq(allTags);
        // Order by most used ones
        return orderBy(uniqueTags, [(tag) => tagCounts[tag]], ["desc"]);
    }, [currentCampaignConfiguration?.tags]);
};
